import { defineComponent as _defineComponent } from 'vue'
interface Props {
  checked: boolean
  disabled?: boolean
  disabledHint?: string
}


export default /*#__PURE__*/_defineComponent({
  __name: 'LegCardShell',
  props: {
    checked: { type: Boolean },
    disabled: { type: Boolean, default: false },
    disabledHint: null
  },
  emits: ["change"],
  setup(__props: any, { emit }: { emit: ({ (e: 'change', checked: boolean): void }), expose: any, slots: any, attrs: any }) {




function onChange(e: Event) {
  emit('change', (e.target as HTMLInputElement).checked)
}

return { __sfc: true,emit, onChange }
}

})